import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Flame } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Compact, sticky streak indicator for the top nav.
 * Renders only for logged-in users. Links to /#streak so the user can claim
 * their daily check-in on Home.
 *
 * Pulses orange when the user can check in today.
 */
export default function HeaderStreakChip() {
  const { user } = useAuth();
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!user) { setState(null); return; }
    api.get("/streak").then((r) => setState(r.data)).catch(() => {});
  }, [user]);

  if (!user || !state) return null;
  const current = state.current || 0;
  const canCheckin = !!state.can_checkin;

  return (
    <Link
      to="/#streak"
      data-testid="header-streak-chip"
      title={canCheckin
        ? `Day ${current} — tap to claim today's check-in`
        : `${current}-day streak locked in. Come back tomorrow.`}
      className={`hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 border-2 font-anton uppercase tracking-widest text-xs transition-colors ${
        canCheckin
          ? "border-[#DD5422] bg-[#DD5422] text-[#0A0E0B] animate-pulse hover:bg-[#FF6B35]"
          : "border-[#DD5422]/60 text-[#DD5422] hover:bg-[#DD5422]/10"
      }`}
    >
      <Flame className="w-4 h-4" strokeWidth={2.5} />
      <span data-testid="header-streak-days">{current}d</span>
      {canCheckin && <span className="text-[10px]">●</span>}
    </Link>
  );
}
